import Spline from "@splinetool/react-spline";





function Projects() {
  return (

<div className="flex w-screen h-screen flex-col items-center  justify-start relative bg-primary pb-10 pt-2">
        
        <div className="flex flex-col  justify-center  border border-zinc-800 rounded-md 
        p-2 hover:border-zinc-600 duration-100 ease-in-out mt-20 w-[95%] 2xl:max-w-[75%] ">
        
        <div className="items-center justify-center w-full h-full">
        <Spline scene="https://boat.southstudios.net/3d-models/puffer/puffer.splinecode" />
       </div>
       </div>
       
       <div className=" w-full flex justify-center items-center mt-2">
            <div className="shadow-md p-4 flex items-center justify-center bg-zinc-900 rounded-3xl ">
              <p className="text-white text-xs sm:text-base">Click Puffer multiple times to inflate him</p>
            </div>
          </div>
          


</div>

    
    
  );
}

export default Projects;
